import { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
// import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';

import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  Paper,
  Typography,
  dialogClasses,
} from '@mui/material';
import { Box, Grid, Stack } from '@mui/system';
import { DataGrid } from '@mui/x-data-grid';
import { post } from 'api';
import { url } from 'config/config';
import moment from 'moment';
import { enqueueSnackbar } from 'notistack';
import EnquiryCreate from 'components/SS/addEnquiry';
import FilePreview from 'components/SS/filePreview';
import IconifyIcon from 'components/base/IconifyIcon';
import DataGridPagination from 'components/pagination/DataGridPagination';
import StyledTextField from 'components/styled/StyledTextField';

const Enquiry = () => {
  const navigate = useNavigate();
  const fileInputRef = useRef();
  const [data, setData] = useState([]);
  const [pdfView, setPdfView] = useState(null);
  const [search, setSearch] = useState('');
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
    search,
  });
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [open, setOpen] = useState(null);
  const [value, setValue] = useState(null);
  const [enquiry, setEnquiry] = useState(null);
  const [openEnquire, setOpenEnquiry] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await post('/users/list_all_enquiry', {
        page: paginationModel.page + 1,
        limit: paginationModel.pageSize,
        search: paginationModel.search,
      });
      if (response.status == 200) {
        setData(response.data.finalData);
        setTotal(response.data.total);
      } else {
        enqueueSnackbar('Error while fetching customers!', {
          variant: 'error',
          autoHideDuration: 3000,
        });
        setData([]);
        setTotal(0);
      }
    } catch (error) {
      console.log('error', error);
      enqueueSnackbar(error.message || 'Error while fetching customers!', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [paginationModel]);

  const ViewButton = ({ row }) => {
    const handleView = () => {
      // setOpen(!open);
      // setEnquiry(row);
      navigate('/quotation_create', { state: row });
    };

    return (
      <span
        onClick={handleView}
        style={{
          cursor: 'pointer',
          color: '#1976d2', // MUI primary blue
          textDecoration: 'underline',
          fontWeight: 500,
        }}
        onMouseEnter={(e) => (e.target.style.color = '#125ea8')} // optional hover
        onMouseLeave={(e) => (e.target.style.color = '#1976d2')}
      >
        Upload
      </span>
      // <IconButton
      //   onClick={handleView}
      //   sx={{
      //     color: '#1976d2',
      //     '&:hover': {
      //       color: '#125ea8',
      //       textDecoration: 'underline',
      //     },
      //   }}
      // >
      //   <UploadFileOutlinedIcon />
      // </IconButton>
    );
  };

  const ShowPage = ({ row }) => {
    const handleView = () => {
      navigate('/enquiry_info', { state: row });
      // navigate('/quotation_create', { state: row });
    };

    return (
      <IconButton onClick={handleView}>
        <RemoveRedEyeOutlinedIcon />
      </IconButton>
    );
  };

  const columns = useMemo(
    () => [
      {
        field: 'view',
        headerName: 'View',
        sortable: false,
        filterable: false,
        minWidth: 40,
        renderCell: (params) => <ShowPage row={params.row} />,
      },

      {
        field: 'client',
        headerName: 'Client',
        minWidth: 200,
        sortable: false,
        filterable: false,
        // valueGetter: ({ name }) => name,
        renderCell: (params) => {
          const { name } = params.row;

          return (
            <Stack
              sx={{
                gap: 1.5,
                alignItems: 'center',
              }}
            >
              <Avatar
                alt={name.toUpperCase()}
                src={name}
                sx={{ width: 24, height: 24, bgcolor: '#977efdff' }}
              />
              <div>
                <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                  {name}
                </Typography>
              </div>
            </Stack>
          );
        },
      },
      {
        field: 'fieldSales',
        headerName: 'Sales Surveyor',
        sortable: false,
        filterable: false,
        minWidth: 160,
        renderCell: (params) => {
          return (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                {params.row.assignSalesSurveyer.firstName} {params.row.assignSalesSurveyer.lastName}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: 'assignManager',
        headerName: 'Sales Manager',
        sortable: false,
        filterable: false,
        minWidth: 150,
        renderCell: (params) => {
          return (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                {params.row.assignManager.firstName} {params.row.assignManager.lastName}
              </Typography>
            </Box>
          );
        },
      },

      {
        field: 'dateOfEnquiery',
        headerName: 'Date Of Enquiery',
        sortable: false,
        filterable: false,
        minWidth: 150,
        renderCell: (params) => {
          return (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                {moment(params.row.createdAt).format('DD/MM/YYYY')}
              </Typography>
            </Box>
          );
        },
      },

      {
        field: 'requirement',
        headerName: 'Requirement',
        sortable: false,
        filterable: false,
        minWidth: 100,
        renderCell: (params) => {
          return (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                {params.row.requirementCapacity} KW
              </Typography>
            </Box>
          );
        },
      },
      {
        field: 'Create Quotation',
        headerName: 'Create Quotation',
        sortable: false,
        filterable: false,
        minWidth: 140,
        renderCell: (params) => <ViewButton row={params.row} />,
      },
      {
        field: 'lastQuotation',
        headerName: 'Last Quotation',
        sortable: false,
        filterable: false,
        minWidth: 150,
        renderCell: (params) => {
          const { lastQuotation } = params.row;
          return (
            <Box>
              {lastQuotation ? (
                <>
                  <IconButton
                    onClick={async (e) => {
                      e.stopPropagation();
                      try {
                        const response = await fetch(`${url}${lastQuotation.url}`, {
                          mode: 'cors',
                        });
                        const blob = await response.blob();
                        const blobUrl = URL.createObjectURL(blob);

                        const link = document.createElement('a');
                        link.href = blobUrl;
                        link.download = `quotation ${params.row.name}`;
                        document.body.appendChild(link);
                        link.click();
                        link.remove();

                        URL.revokeObjectURL(blobUrl);
                      } catch (err) {
                        console.error('Download error:', err);
                      }
                    }}
                  >
                    {/* <IconifyIcon icon="mdi:file-pdf-box" /> */}
                    <PictureAsPdfIcon color="error" />
                  </IconButton>
                  <IconButton
                    onClick={async () => {
                      setPdfView(lastQuotation.url);
                    }}
                  >
                    <RemoveRedEyeOutlinedIcon />
                  </IconButton>
                </>
              ) : (
                <>
                  <IconButton disabled>
                    <PictureAsPdfIcon color="error" />
                  </IconButton>
                  <IconButton disabled>
                    <RemoveRedEyeOutlinedIcon />
                  </IconButton>
                </>
              )}
            </Box>
          );
        },
      },
      //   {
      //     field: 'action',
      //     headerName: 'Action',
      //     filterable: false,
      //     sortable: false,
      //     align: 'right',
      //     width: 60,
      //     headerAlign: 'right',
      //     renderCell: () => <DashboardMenu />,
      //   },
    ],
    [],
  );
  const handleClose = () => {
    setEnquiry(null);
    setOpen(false);
    setValue(null);
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('file', value);
      const res = await post(`users/create_quotation/${enquiry._id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (res.status) {
        enqueueSnackbar(res.message || 'Quotation Uploaded Successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      } else {
        enqueueSnackbar(res.message || 'Error while Uploading Quotation to Enquiry', {
          variant: 'error',
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error while Uploading Quotation to Enquiry', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    } finally {
      setEnquiry(null);
      setOpen(false);
      setValue(null);
      fetchData();
    }
  };

  return (
    <>
      <Paper sx={{ flex: 1, p: { xs: 3, md: 5 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <StyledTextField
            id="search-box"
            type="search"
            fullWidth
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search enquiry"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <IconifyIcon icon="material-symbols:search-rounded" fontSize={20} />
                  </InputAdornment>
                ),
              },
            }}
            sx={{
              maxWidth: { sm: 200, md: 240 },
              flexGrow: { xs: 1, sm: 0 },
              mb: 3,
            }}
          />
          <Button variant="soft" shape="square" color="neutral" sx={{ gap: 0.5, p: 1 }}>
            <IconifyIcon icon="material-symbols:add-2-rounded" />
            <Box
              component="span"
              sx={{ display: { xs: 'none', sm: 'block' } }}
              onClick={() => setOpenEnquiry(!openEnquire)}
            >
              Add enquiry
            </Box>
          </Button>
        </Box>

        <DataGrid
          rowHeight={72}
          rows={data}
          loading={loading}
          columns={columns}
          getRowId={(row) => row._id}
          pagination
          paginationMode="server"
          rowCount={total}
          paginationModel={paginationModel} // { page: 0, pageSize: 10 }
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[5, 10, 20]}
          // checkboxSelection
          sx={{
            '& .margin': {
              pr: 3,
            },
            '& .MuiDataGrid-columnHeaders': {
              minWidth: '100%',
            },
          }}
          slots={{
            basePagination: (props) => <DataGridPagination showFullPagination {...props} />,
          }}
        />
      </Paper>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="dialog-title"
        component="form"
        onSubmit={onSubmit}
        sx={{
          [`& .${dialogClasses.paper}`]: {
            p: 0,
            borderRadius: 6,
            width: 1,
            maxWidth: 600,
          },
        }}
      >
        <Stack sx={{ p: 3, pb: 2, justifyContent: 'space-between', position: 'sticky', top: 0 }}>
          <DialogTitle id="dialog-title" sx={{ p: 0, typography: 'h6' }}>
            {`Send Quotation to ${enquiry?.name}`}
          </DialogTitle>
          <Button
            variant="text"
            size="small"
            color="neutral"
            onClick={handleClose}
            sx={{ minWidth: 0, p: 0.5 }}
          >
            <IconifyIcon icon="material-symbols:close-rounded" sx={{ fontSize: 20 }} />
          </Button>
        </Stack>
        <DialogContent sx={{ px: 3, py: 1 }}>
          <Grid container spacing={2}>
            <Grid item size={{ xs: 8, sm: 8 }}>
              <Button variant="outlined" component="label" fullWidth sx={{ height: '56px' }}>
                {value ? value.name : 'Upload Quotation'}
                <input
                  ref={fileInputRef}
                  type="file"
                  hidden
                  accept="application/pdf"
                  onChange={(e) => {
                    const file = e.target.files[0];

                    setValue(file);
                  }}
                />
              </Button>
            </Grid>
            <Grid item size={{ xs: 4, sm: 4 }}>
              {value && (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={() => window.open(URL.createObjectURL(value))}
                >
                  <PictureAsPdfIcon color="error" sx={{ fontSize: 40 }} />
                  <Typography variant="caption">Click For Preview</Typography>
                </Box>
              )}
            </Grid>
          </Grid>
          {/* </form> */}
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 2 }}>
          <Button type="submit" variant="contained" autoFocus disabled={!value}>
            Create
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={Boolean(pdfView)}
        onClose={() => setPdfView(null)}
        aria-labelledby="dialog-title"
        // component="form"
        // onSubmit={onSubmit}
        sx={{
          [`& .${dialogClasses.paper}`]: {
            p: 0,
            borderRadius: 6,
            width: 1,
            maxWidth: 600,
          },
        }}
      >
        <Stack sx={{ p: 3, pb: 2, justifyContent: 'space-between', position: 'sticky', top: 0 }}>
          <DialogTitle id="dialog-title" sx={{ p: 0, typography: 'h6' }}>
            {`Last Quotation Of ${enquiry?.name}`}
          </DialogTitle>
          <Button
            variant="text"
            size="small"
            color="neutral"
            onClick={() => setPdfView(null)}
            sx={{ minWidth: 0, p: 0.5 }}
          >
            <IconifyIcon icon="material-symbols:close-rounded" sx={{ fontSize: 20 }} />
          </Button>
        </Stack>
        <DialogContent sx={{ px: 3, py: 1 }}>
          <FilePreview src={`${url}${pdfView}`} />
          {/* <Grid container spacing={2}>
            <Grid item size={{ xs: 8, sm: 8 }}>
              <Button variant="outlined" component="label" fullWidth sx={{ height: '56px' }}>
                {value ? value.name : 'Upload Quotation'}
                <input
                  ref={fileInputRef}
                  type="file"
                  hidden
                  accept="application/pdf"
                  onChange={(e) => {
                    const file = e.target.files[0];

                    setValue(file);
                  }}
                />
              </Button>
            </Grid>
            <Grid item size={{ xs: 4, sm: 4 }}>
              {value && (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={() => window.open(URL.createObjectURL(value))}
                >
                  <PictureAsPdfIcon color="error" sx={{ fontSize: 40 }} />
                  <Typography variant="caption">Click For Preview</Typography>
                </Box>
              )}
            </Grid>
          </Grid>
          </form> */}
        </DialogContent>
        {/* <DialogActions sx={{ p: 3, pt: 2 }}>
          <Button type="submit" variant="contained" autoFocus disabled={!value}>
            Create
          </Button>
        </DialogActions> */}
      </Dialog>
      <EnquiryCreate open={openEnquire} setOpen={setOpenEnquiry} fetchData={fetchData} />
    </>
  );
};

export default Enquiry;
